export const isPwa = () => {
  if (window.navigator && (window.navigator as any).standalone === true) {
    return true;
  }
  return window.matchMedia && window.matchMedia('(display-mode: standalone)').matches;
};
